import { Component, OnInit } from '@angular/core';
import { CookieService } from '../../shared/cookie.service';
import { RefererService } from '../referer.service';
import { InfoBlockBehaviour } from 'app/contentful/info-block-behaviour';

@Component({
    selector: 'sbw-accept-cookies',
    templateUrl: './accept-cookies.component.html',
    styleUrls: ['./accept-cookies.component.css']
})
export class AcceptCookiesComponent implements OnInit {

    public displayAcceptCookies: boolean = true
    public displayRejectCookies: boolean = false
    public displayReadMoreAboutCookies: boolean = false
    InfoBlockBehaviourEnum: typeof InfoBlockBehaviour = InfoBlockBehaviour;

    constructor(private cookieService: CookieService, private referer: RefererService) { }

    ngOnInit() {
        if (this.isReferredFromDfdsWebsite()) {
            this.cookieService.setCookesAccepted(true)
        }
        this.displayAcceptCookies = !this.cookieService.getCookesAccepted()
    }

    public acceptCookies() {
        this.cookieService.setCookesAccepted(true)
        this.displayAcceptCookies = false;
    }

    public rejectCookies() {
        this.cookieService.setCookesAccepted(false)
        this.displayRejectCookies = true;

    }
    public readMoreAboutCookies() {
        this.displayReadMoreAboutCookies = true;
    }

    isReferredFromDfdsWebsite(): boolean {
        return this.cookieService.getCookie('GDPR') == "true" ? true : false;
    }

    getHeading(evt) {
        return evt && evt.heroBlock && evt.heroBlock.title
    }

}
